module.exports = __webpack_public_path__ + "img/milano_aler_background_hero.8dfbbb9c.png";